import { render, staticRenderFns } from "./IndexPage.vue?vue&type=template&id=1d916f8e&"
import script from "./IndexPage.vue?vue&type=script&lang=ts&"
export * from "./IndexPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d916f8e')) {
      api.createRecord('1d916f8e', component.options)
    } else {
      api.reload('1d916f8e', component.options)
    }
    module.hot.accept("./IndexPage.vue?vue&type=template&id=1d916f8e&", function () {
      api.rerender('1d916f8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistic/rack/IndexPage.vue"
export default component.exports